import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import Axios from 'axios';
import '../style/Traductor.scss'
import downArrow from "../props/downArrow.png"
import upArrow from "../props/upArrow.png";
import { publish, subscribe, unsubscribe} from '../events'
import Tooltip from './Tooltip'

const Attribute = (keyAttribute) => {
    const search = useLocation().search;
    // URL PARAMS
    const pimInstance = keyAttribute.pimInstance;
    const quableDocID = keyAttribute.quableDocID;
    const quableDocType = keyAttribute.quableDocType;
    const token = keyAttribute.token;
    const quableUserID = keyAttribute.quableUserID;
    let backURL = "/api/save"
    let errorURL = "/api/error"
    if (process.env.NODE_ENV === "development")
    {
        backURL="http://localhost:4000/api/save"
        errorURL="http://localhost:4000/api/error"
    }
    //States
    const [isExceedingMaxChars, setIsExceedingMaxChars] = useState(false);
    const [pimData,setPimData]=useState(keyAttribute.value?keyAttribute.value:"_")
    const [actualTranslation,setActualTranslation]=useState(keyAttribute.actualTranslation?keyAttribute.actualTranslation:"_")
    //bon j'ai inversé les deux, pas grave
    const [serviceTrad, setServiceTrad]=useState(keyAttribute.trad)
    const [idTranslation, setIdTranslation]=useState(keyAttribute.translationId)
    const [chosenTrad,setChosenTrad]=useState("")
    const [targetLocale,setTargetLocale]=useState(keyAttribute.locale)
    const [checked,setChecked]=useState(true)
    const checkedRef = useRef(checked)
    const serviceTradRef = useRef(serviceTrad)
    const idTranslationRef = useRef(idTranslation)
    const targetLocaleRef = useRef(targetLocale)
    const [isTextAreaVisible, setTextAreaVisible] = useState(false);
    const [error, setError] = useState({})
    //Event Handling
    const chargeIntoTraductor = () => {
        //console.log("Throwing event 'chargeIntoTraductor'")
        publish('chargeIntoTraductor',{instruction:!checkedRef.current,attributeCode:keyAttribute.attributeCode});
    }
    const fleche=" → "
    const toggleTextArea = () => {
        setTextAreaVisible(!isTextAreaVisible);
    };

    //Logical Functions
    async function handleValidation() {
    const { onSaveStart, onSaveEnd } = keyAttribute;

    if (checkedRef.current && serviceTradRef.current !== "" && serviceTradRef.current !== "x") {
        onSaveStart(keyAttribute.attributeCode);

        const contenu = {};
        const attributes = {};
        contenu[targetLocaleRef.current] = serviceTradRef.current;
        attributes[keyAttribute.attributeCode] = contenu;

        let traduct;
        try {
            traduct = await Axios({
                method: "PUT",
                url: `${pimInstance}/documents/${quableDocID}`,
                headers: {
                    'content-type': 'application/ld+json',
                    Accept: "application/hal+json,",
                    Authorization: "Bearer " + token,
                },
                data: {
                    attributes: attributes
                }
            });

            if (traduct && traduct.status === 200) {
                // Save translation in local API
                try {
                    await Axios({
                        method: "POST",
                        url: backURL,
                        data: {
                            idTranslation: idTranslationRef.current,
                            translation: serviceTradRef.current,
                            userName: keyAttribute.userName
                        }
                    });
                } catch (e) {
                    setError({
                        'message': "A minor Error has happened. Contact the administrator",
                        'gravity': 'minor'
                    });
                    console.log("Error while saving the data", e);
                }
            } else {
                throw new Error("Error sending the data to Quable (non-200 status)");
            }
        } catch (e) {
            setError({
                'message': "A major Error has happened. Contact the administrator",
                'gravity': 'major'
            });
            console.log("Major error in handleValidation:", e);

            // Optional: send error log to backend
            try {
                await Axios({
                    method: "POST",
                    url: errorURL,
                    data: {
                        message: "Error sending the data to Quable",
                        gravity: "major"
                    }
                });
            } catch (ee) {
                // Silent fail for logging error
            }
        } finally {
            onSaveEnd(keyAttribute.attributeCode);
        }
    }
}


    //Effects
    useEffect(()=>{
        chargeIntoTraductor()
        setChecked(false)
    },[])

    useEffect(()=>{
        setPimData(keyAttribute.value?keyAttribute.value:"_")
    }, onclick)

    useEffect(()=>{
        setActualTranslation(keyAttribute.actualTranslation?keyAttribute.actualTranslation:"_")
    }, onclick)

    useEffect(() => {
        setIdTranslation(keyAttribute.translationId)
    }, [keyAttribute.translationId])

    useEffect(()=>{
        setServiceTrad(keyAttribute.trad)
    },[keyAttribute.trad])

    useEffect(()=>{
        setTargetLocale(keyAttribute.locale)
    },[keyAttribute.locale])

    useEffect(()=>{
        setChosenTrad(keyAttribute.trad)
    },[serviceTrad])



    useEffect(() => {
        const resetStates =  () => {
            setChecked(false);
            checkedRef.current = false
            setServiceTrad('x');
            serviceTradRef.current = 'x';
        };
        subscribe("resetAttributeStates", resetStates);

        return () => {
            unsubscribe("resetAttributeStates", resetStates);
        }
    }, []);

    useEffect(() => {
        //unsubscribe("sendToPim", () => console.log("killed event sendToPIM"))
        subscribe("sendToPim", () => {
            if (!checked)
            {
                console.log("Caught event sendToPIM ",checked.toString())
            }
            handleValidation()
        });

        subscribe("checkAllEvent",event=>{
            if(checkedRef.current != event.detail.instruction)
            {
                setChecked(event.detail.instruction)
                chargeIntoTraductor()
            }
        })

        return () => {
            unsubscribe("sendToPim", () => console.log("killed event sendToPIM"));
            unsubscribe("checkAllEvent", () => console.log("killed event checkAllEvent"))
        }
    },[])

    useEffect(()=>{
        serviceTradRef.current=serviceTrad
        idTranslationRef.current=idTranslation
        checkedRef.current=checked
        targetLocaleRef.current=targetLocale
    })

    return(<>
        <div key={keyAttribute.attribute} className='attributeDisplay'>
            <label className="typeText" style={{marginRight: "1%"}}>{keyAttribute.attribute}</label>
            <div className='attributeDiv'>
                <input
                    type='checkbox'
                    checked={checked}
                    onChange={() => {
                        setChecked(!checked)
                        chargeIntoTraductor()
                    }}
                />
                <textarea
                    type="text"
                    value={pimData}
                    disabled={true}
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        maxHeight: '10%',
                        resize: 'none',
                        minHeight: '60px'
                    }}
                />
                {fleche}
                <div
                    style={{
                        position: "relative",
                        width: '50%',
                        boxSizing: 'border-box',
                        maxHeight: '10%',
                        resize: 'none',
                        minHeight: '60px'
                    }}
                >
                    <textarea
                        type="text"
                        value={serviceTrad}
                        //maxLength={keyAttribute.maxCharactersAllowed}
                        onChange={event => {
                            const newTraduction = event.target.value;
                            const exceedsLimit = newTraduction.length > keyAttribute.maxCharactersAllowed;
                            setIsExceedingMaxChars(exceedsLimit);
                            publish("attributeCharLimitExceeded", { attributeCode: keyAttribute.attributeCode, exceedsLimit });
                            if (chosenTrad === "") {
                                setChosenTrad(serviceTrad)
                            }
                            setServiceTrad(newTraduction);
                        }}
                        disabled={(serviceTrad === "x") || (!checked && chosenTrad === "")}

                        style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            maxHeight: '10%',
                            resize: 'none',
                            minHeight: '60px'
                        }}
                    />
                    <div
                        className="typeText"
                        style={{
                            position: "absolute",
                            top: "-20%",
                            right: "0",
                        }}
                    >
                        {serviceTrad.length}
                        {keyAttribute.maxCharactersAllowed !== 999999 && `/${keyAttribute.maxCharactersAllowed}`}
                    </div>
                    {serviceTrad.length >= keyAttribute.maxCharactersAllowed &&
                        <p style={{
                            color: "red",
                            position: "absolute",
                            right: "45%",
                            bottom: "90%",

                        }}>⚠️ Max : {keyAttribute.maxCharactersAllowed} caractères</p>}
                    {error && error.gravity === 'minor' && <div className="attributeErrorMessage" style={{
                        color: "orange",
                        position: "absolute",
                        right: "30%",
                        bottom: "105%",
                    }}>{error.message}</div>}
                    {error && error.gravity === 'major' && <div className="attributeErrorMessage" style={{
                        color: "red",
                        position: "absolute",
                        right: "30%",
                        bottom: "105%",
                    }}>{error.message}</div>}
                </div>
            </div>
            <div >
                <Tooltip text={`Click to show/hide the value of "${keyAttribute.attribute}" in Quable for the selected translation language.`}>
                    <img onClick={toggleTextArea} src={isTextAreaVisible ? upArrow : downArrow} alt="Toggle"
                         style={{width: "20px", height: "20px", marginRight: "9px", cursor: 'pointer'  }}/>
                </Tooltip>
            </div>
            <div>
                {isTextAreaVisible && (
                    <textarea
                        type="text"
                        value={actualTranslation}
                        style={{
                            width: '50%',
                            minHeight: '80px',
                            marginTop: '10px',
                            marginLeft: '50%',
                        }}
                        disabled={true}
                    />
                )}
            </div>
        </div>
    </>);
}

export default Attribute;